export default value => {
  if (value == null) {
    return true
  }
  for (let key in value) {
    if (hasOwnProperty.call(value, key)) {
      return false
    }
  }
  return true
}
